import React, { useEffect } from 'react';
import { SubTable, Table, DownIcon, UpIcon } from './styled';
import { useLocalStore, useObserver } from 'mobx-react-lite';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import { timeUtils } from '../../../../../../../common/utils/timeUtil';
import { ScoreDetailService } from '../../../../../../../common/services';

const InternationalOddsSubTable = observer(
  ({ oddsId, type, selectedTab, close }) => {
    const store = useLocalStore(() => ({
      history: [],
      history_list: {},
      loading: false,
      init: false,
      get getTimeLineSorted() {
        const { history, history_list } = store;
        const descHistory = history.sort(descsort);

        const result = [];

        function oddsMathValue(odds, preOdds) {
          let mathValue = '-';
          let state = '';
          if (!!preOdds) {
            const math = (odds - preOdds).toFixed(2);
            if (math > 0) {
              mathValue = `+${math}`;
              state = 'up';
            } else {
              mathValue = math;
              state = 'down';
            }
          } else {
            mathValue = '-';
            state = '';
          }
          return { value: mathValue, state: state };
        }

        function descsort(a, b) {
          const parseA = new Date(a).getTime();
          const parseB = new Date(b).getTime();
          if (parseA > parseB) return -1;
          else if (parseA == parseB) return 0;
          else return 1;
        }

        if (descHistory.length > 0) {
          descHistory.forEach((obj_list) => {
            let timeLineData = {};
            let optionValue_type = '';
            let optionValue_state = '';
            timeLineData = {
              date: timeUtils.matchTimeFormat(obj_list),
              id: history_list[obj_list][0].id
            };
            if (!!history_list[obj_list][0].preOptionValue) {
              optionValue_state = oddsMathValue(
                history_list[obj_list][0].optionValue,
                history_list[obj_list][0].preOptionValue
              ).state;
            }
            if (
              history_list[obj_list][0].type === 'HANDICAP_WIN' ||
              history_list[obj_list][0].type === 'HANDICAP_LOSS'
            ) {
              optionValue_type = 'handicap';
            } else if (
              history_list[obj_list][0].type === 'OVER' ||
              history_list[obj_list][0].type === 'UNDER'
            ) {
              optionValue_type = 'unover';
            } else {
              optionValue_type = 'windrawloss';
            }
            timeLineData = {
              ...timeLineData,
              optionValue: {
                type: optionValue_type,
                state: optionValue_state,
                value: history_list[obj_list][0].optionValue
              }
            };
            history_list[obj_list].forEach((obj) => {
              if (
                obj.type === 'WIN' ||
                obj.type === 'HANDICAP_WIN' ||
                obj.type === 'UNDER'
              ) {
                timeLineData = {
                  ...timeLineData,
                  win: {
                    type: obj.type,
                    odds: obj.odds.toFixed(2),
                    mathValue: oddsMathValue(obj.odds, obj.preOdds)
                  }
                };
              } else if (
                obj.type === 'LOSS' ||
                obj.type === 'HANDICAP_LOSS' ||
                obj.type === 'OVER'
              ) {
                timeLineData = {
                  ...timeLineData,
                  loss: {
                    type: obj.type,
                    odds: obj.odds.toFixed(2),
                    mathValue: oddsMathValue(obj.odds, obj.preOdds)
                  }
                };
              } else {
                timeLineData = {
                  ...timeLineData,
                  draw: {
                    type: obj.type,
                    odds: obj.odds.toFixed(2),
                    mathValue: oddsMathValue(obj.odds, obj.preOdds)
                  }
                };
              }
            });

            result.push(timeLineData);
          });
        }

        return result;
      },
      async getHistory(oddsId) {
        store.loading = true;

        const result = await ScoreDetailService.getOddsTimeLine(oddsId);

        runInAction(() => {
          store.history = Object.keys(result);
          store.history_list = result;
          store.loading = false;
        });
      }
    }));

    useEffect(() => {
      store.getHistory(oddsId);
    }, []);
    return (
      <Table>
        <colgroup>
          <col width={150} />
          <col width={110} />
          <col width={110} />
          <col width={110} />
          <col width={110} />
          <col width={27} />
        </colgroup>
        <thead>
          <tr>
            <th></th>
            <th>기준</th>
            <th>{selectedTab === 'unover' ? '오버' : '승'}</th>
            <th>무</th>
            <th>{selectedTab === 'unover' ? '언더' : '패'}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan={6}>
              <SubTable>
                <colgroup>
                  <col width={150} />
                  <col width={110} />
                  <col width={110} />
                  <col width={110} />
                  <col width={110} />
                  <col width={27} />
                </colgroup>
                <tbody>
                  {useObserver(() => {
                    const { getTimeLineSorted } = store;

                    if (getTimeLineSorted.length > 0) {
                      return getTimeLineSorted.map((item) => {
                        return (
                          <tr key={item.id}>
                            <td className="date">
                              {timeUtils.MmDdHhMm(item.date)}
                            </td>
                            <td className="odds_value">
                              <span>
                                {!!item.optionValue.value &&
                                  item.optionValue.value}
                              </span>
                            </td>
                            <td className="odds_value">
                              <span>{!!item.win ? item.win.odds : '-'}</span>

                              {!!item.win &&
                                item.win.mathValue.state === 'up' && <UpIcon />}
                              {!!item.win &&
                                item.win.mathValue.state === 'down' && (
                                  <DownIcon />
                                )}
                            </td>
                            <td className="odds_value">
                              <span>{!!item.draw ? item.draw.odds : '-'}</span>
                              {!!item.draw &&
                                item.draw.mathValue.state === 'up' && (
                                  <UpIcon />
                                )}
                              {!!item.draw &&
                                item.draw.mathValue.state === 'down' && (
                                  <DownIcon />
                                )}
                            </td>
                            <td className="odds_value">
                              <span>{!!item.loss ? item.loss.odds : '-'}</span>
                              {!!item.loss &&
                                item.loss.mathValue.state === 'up' && (
                                  <UpIcon />
                                )}
                              {!!item.loss &&
                                item.loss.mathValue.state === 'down' && (
                                  <DownIcon />
                                )}
                            </td>
                            <td></td>
                          </tr>
                        );
                      });
                    }
                  })}
                </tbody>
              </SubTable>
            </td>
          </tr>
        </tbody>
      </Table>
    );
  }
);

export default InternationalOddsSubTable;
